import React from 'react'
import { observer, inject } from 'mobx-react'

import { remoteChangeToastModel } from './model'

import './styles.scss'

/**
 * Confirms that the tab picked up someone else's save. See FE-1354.
 *
 * As a warning, it confirms the user loaded the newer version in place of
 * their unsaved changes (FE-1441). It fades on its own either way; by then the
 * swap has happened and there is nothing to choose.
 */
export const RemoteChangeToast = ({ app }) => {
  if (!remoteChangeToastModel.show) {
    return null
  }

  const { messageKey, warning } = remoteChangeToastModel

  return (
    <div
      className={`remote-change-toast${
        warning ? ' remote-change-toast--warning' : ''
      }`}
      role="status"
      aria-live="polite"
    >
      <span
        className={`bp6-icon ${
          warning ? 'bp6-icon-warning-sign' : 'bp6-icon-tick'
        } remote-change-toast--icon`}
      />
      <span className="remote-change-toast--message">
        {app.formatMessage(messageKey)}
      </span>
    </div>
  )
}

export default inject('app')(observer(RemoteChangeToast))
